module.exports = __webpack_public_path__ + "static/media/associati_print_header.9ded3153.png";